import React from "react";

export const Sweeping = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="1.2em"
    width="1.2em"
    aria-hidden="true"
    viewBox="-0.5 -0.5 24 24"
  >
    <defs></defs>
    <title>sweeping-2</title>
    <path
      d="M10.512 21.639A8.185 8.185 0 0 1 8.26 19.167"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M13.597 20.317a8.189 8.189 0 0 1 -2.426 -2.306"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M17.592 18.304s-3.944 0.997 -6.658 -5.399a4.053 4.053 0 0 0 -5.314 -2.149c-3.822 1.59 -2.148 5.314 -2.148 5.314s0.788 4.785 3.291 6.239c4.863 0.15 10.828 -4.005 10.828 -4.005Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m3.861 16.001 7.073 -2.867"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M4.253 11.596C2.307 8.485 1.706 2.712 1.639 1.998a1.198 1.198 0 0 1 2.386 -0.226c0.173 1.81 0.924 6.678 2.382 8.741"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M17.173 9.297a0.479 0.479 0 1 0 0.958 0 0.479 0.479 0 1 0 -0.958 0"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M20.409 12.411a0.479 0.479 0 1 0 0.958 0 0.479 0.479 0 1 0 -0.958 0"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M15.663 13.613a0.479 0.479 0 1 0 0.958 0 0.479 0.479 0 1 0 -0.958 0"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
  </svg>
);

export const Sports = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="1.2em"
    width="1.2em"
    aria-hidden="true"
    viewBox="-0.5 -0.5 24 24"
  >
    <defs></defs>
    <path
      d="M22.183 14.133a2.875 2.875 0 0 0 -2.979 -1.897L2.984 13.763a2.875 2.875 0 0 0 0.062 5.731"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M2.295 5.516a1.917 1.917 0 1 0 3.833 0 1.917 1.917 0 1 0 -3.833 0"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m3.629 13.704 0.219 -4.069a0.958 0.958 0 0 1 1.4 -0.799l2.052 1.07 1.907 -0.601a0.958 0.958 0 1 1 0.575 1.829l-2.285 0.72a0.958 0.958 0 0 1 -0.73 -0.064l-1.085 -0.566"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m8.35 11.581 -1.09 4.577"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M10.441 2.895a1.917 1.917 0 1 0 3.833 0 1.917 1.917 0 1 0 -3.833 0"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M9.967 20.29h0a1.875 1.875 0 0 0 2.651 0h0a1.875 1.875 0 0 1 2.651 0l0.264 0.264a1.878 1.878 0 0 0 2.597 0.057 3.967 3.967 0 0 0 1.115 -1.645 4.483 4.483 0 0 0 0 -3.711c1.59 0 3.181 0.53 3.181 3.181"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M7.26 16.158a1.691 1.691 0 0 0 -1.733 1.065l-0.671 2.796a2.396 2.396 0 0 0 2.796 0.671l0.671 -2.796a1.691 1.691 0 0 0 -1.064 -1.736Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m17.629 6.954 1.363 1.8"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M21.351 12.922a2.539 2.539 0 0 0 1.074 -1.185l-1.465 -2.476a1.691 1.691 0 0 0 -1.968 -0.507 1.69 1.69 0 0 0 -0.508 1.968l0.886 1.503"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m14.326 12.696 -0.414 -4.142 2.143 0.306a0.958 0.958 0 0 0 1.026 -0.592l0.958 -2.396a0.958 0.958 0 0 0 -1.781 -0.712l-0.678 1.696 -2.609 -0.372A0.958 0.958 0 0 0 11.883 7.528l0.531 5.348"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
  </svg>
);

export const Conversation = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="1.2em"
    width="1.2em"
    aria-hidden="true"
    viewBox="-0.5 -0.5 24 24"
  >
    <g>
      <path
        d="m6.229 5.271 10.542 0"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="m6.229 8.146 6.229 0"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="m12.938 13.896 5.75 0"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="m12.938 16.771 5.75 0"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="m6.229 11.021 2.396 0"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="m7.667 17.892 -6.363 2.952L3.833 15.889a8.242 8.242 0 0 1 -3.354 -6.421C0.479 4.504 5.415 0.479 11.5 0.479s11.021 4.025 11.021 8.989"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="M9.296 15.697c0 2.98 2.961 5.395 6.613 5.395a7.935 7.935 0 0 0 2.3 -0.345l3.833 1.773 -1.485 -2.971a4.945 4.945 0 0 0 1.984 -3.833c0 -2.98 -2.961 -5.395 -6.613 -5.395s-6.632 2.396 -6.632 5.376Z"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
    </g>
  </svg>
);

export const Ecological = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="1.2em"
    width="1.2em"
    aria-hidden="true"
    viewBox="-0.5 -0.5 24 24"
  >
    <g>
      <path
        d="M14.854 7.14c-1.15 0.776 -1.744 2.175 0 3.354 0.958 2.396 2.741 1.754 3.833 0.642a6.593 6.593 0 0 0 0.824 -5.913c-1.715 1.275 -3.22 0.958 -4.658 1.917Z"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="M11.5 3.757c1.246 1.466 1.917 3.383 -1.064 4.677 -1.351 3.019 -3.412 1.917 -4.792 0.287S3.833 2.789 4.983 0.508C7.216 2.386 9.967 1.917 11.5 3.757Z"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="M17.25 8.625c-2.875 1.438 -4.313 5.271 -4.313 5.271A20.642 20.642 0 0 0 6.938 3.92"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="M0.958 13.925h2.875s0.479 0 0.479 0.479v6.708s0 0.479 -0.479 0.479H0.958s-0.479 0 -0.479 -0.479v-6.708s0 -0.479 0.479 -0.479"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="M4.313 20.125c10.283 3.431 6.488 3.46 18.208 -2.396a2.635 2.635 0 0 0 -2.875 -0.958L15.4 18.208"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="M4.313 14.883h2.875a6.325 6.325 0 0 1 4.313 1.917h2.875a0.958 0.958 0 1 1 0 1.917H9.104"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
    </g>
  </svg>
);

export const MountenClimbing = () => (
  <svg
    viewBox="-0.5 -0.5 24 24"
    height="1.2em"
    width="1.2em"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.625 2.871a2.396 2.396 0 1 0 4.792 0 2.396 2.396 0 1 0 -4.792 0Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M12.267 9.104a0.958 0.958 0 0 1 -0.739 -0.347L9.679 6.691a1.438 1.438 0 0 0 -2.324 0.287l-3.345 6.212A1.453 1.453 0 0 0 3.833 13.896v3.015l-1.765 3.528a1.438 1.438 0 1 0 2.572 1.286l1.917 -3.833A1.438 1.438 0 0 0 6.708 17.25v-1.629l1.697 0.309a1.438 1.438 0 0 1 1.15 1.102l0.544 2.45a1.438 1.438 0 0 0 2.806 -0.623l-0.543 -2.454a4.303 4.303 0 0 0 -3.438 -3.307L7.475 12.834l1.459 -2.709a4.461 4.461 0 0 0 3.567 1.854H14.854a1.438 1.438 0 0 0 0 -2.875s-1.741 0 -2.588 0Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M3.093 10.13a0.958 0.958 0 0 1 -1.311 0.344L0.958 9.99a0.958 0.958 0 0 1 -0.349 -1.311l2.659 -4.551a0.958 0.958 0 0 1 1.311 -0.344l0.827 0.484A0.958 0.958 0 0 1 5.75 5.578Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m8.625 21.079 -1.438 1.438 15.333 0"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M22.042 0.479 20.447 2.875A1.917 1.917 0 0 0 20.125 3.929v2.939a1.917 1.917 0 0 1 -0.562 1.355l-0.793 0.793A1.917 1.917 0 0 0 18.208 10.372v4.468c0 1.129 -1.49 3.003 -2.741 3.843"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
  </svg>
);

export const NoSmoking = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="1.2em"
    width="1.2em"
    aria-hidden="true"
    viewBox="-0.5 -0.5 24 24"
  >
    <g>
      <path
        d="M5.271 14.854H3.833a0.479 0.479 0 0 1 -0.479 -0.479v-2.875a0.479 0.479 0 0 1 0.479 -0.479h5.271"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="M11.979 11.021H22.042a0.479 0.479 0 0 1 0.479 0.479v2.875a0.479 0.479 0 0 1 -0.479 0.479H8.146"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="m17.729 11.021 0 3.833"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="m1.438 11.021 0 3.833"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="M6.229 0.479a2.875 2.875 0 0 1 -2.875 2.875 2.875 2.875 0 0 0 -2.875 2.875v1.917"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="M8.146 2.396a2.875 2.875 0 0 1 -2.875 2.875 2.875 2.875 0 0 0 -2.875 2.875"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="m22.521 0.479 -22.042 22.042"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
    </g>
  </svg>
);

export const Pets = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    height="1.2em"
    width="1.2em"
    aria-hidden="true"
    viewBox="-0.5 -0.5 24 24"
  >
    <path
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="m21.64 18.029 -3.642 3.642c-0.479 0.479 -1.246 0.479 -1.629 0 -0.479 -0.479 -0.479 -1.246 0 -1.629m0 0 -1.246 1.246c-0.479 0.479 -1.246 0.479 -1.629 0 -0.479 -0.479 -0.479 -1.246 0 -1.629m2.875 0.383 1.725 -1.725m-4.6 1.342 -0.383 0.383c-0.479 0.479 -1.246 0.479 -1.629 0 -0.479 -0.479 -0.479 -1.246 0 -1.629l0.863 -0.863m1.15 2.108 2.492 -2.492m-3.642 0.383c-0.479 0.479 -1.246 0.479 -1.629 0 -0.383 -0.479 -0.479 -1.246 0 -1.629l2.971 -2.971m-1.342 4.6 2.108 -2.013m-0.767 -2.588c-0.479 0.479 -1.246 0.479 -1.629 0 -0.479 -0.479 -0.479 -1.246 0 -1.629l3.258 -3.258c0.863 -0.863 2.013 -1.246 3.163 -0.958l1.725 0.383c0.383 0.096 0.767 0 1.054 -0.287l1.246 -1.246m-8.817 6.996 1.246 -1.245"
      strokeWidth="1"
    ></path>
    <path
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="m15.231 5.716 -0.537 -0.431s-0.355 -3.378 -2.75 -4.544c-0.335 -0.064 -1.022 3.655 -1.022 3.655s-2.035 -0.101 -2.662 0.26c-1.751 1.006 -2.379 2.588 -2.379 2.588s-2.417 0.341 -4.073 0.675c-2.434 0.379 -0.138 4.236 0.632 5.006 0.77 0.77 2.974 0.724 3.588 0.77 0.613 0.047 1.177 0.448 1.297 1.12l0.728 7.044"
      strokeWidth="1"
    ></path>
    <path
      stroke="#000000"
      strokeLinecap="round"
      d="m20.706 18.958 1.247 1.707"
      strokeWidth="1"
    ></path>
  </svg>
);

export const Religion = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="1.2em"
    width="1.2em"
    aria-hidden="true"
    viewBox="-0.5 -0.5 24 24"
  >
    <g>
      <path
        d="M16.598 21.208a2.817 2.817 0 0 1 -0.307 -1.284V15.333a4.792 4.792 0 0 0 -9.583 0v4.59a2.817 2.817 0 0 1 -0.307 1.284L5.75 22.521h11.5Z"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="M8.625 4.044A5.549 5.549 0 0 0 12.621 5.75a5.664 5.664 0 0 0 2.204 -0.45"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="M8.146 5.75a3.354 3.354 0 1 0 6.708 0 3.354 3.354 0 1 0 -6.708 0"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="m7.188 0.479 8.625 0"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="M6.775 10.139C4.792 9.583 2.607 8.548 1.553 7.283a0.24 0.24 0 0 0 -0.259 -0.077 0.259 0.259 0 0 0 -0.163 0.22c-0.105 3.009 1.208 7.494 3.402 6.948a1.428 1.428 0 0 0 1.917 1.438 1.783 1.783 0 0 0 0.259 0.863"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="M16.225 10.139c1.917 -0.585 4.169 -1.591 5.223 -2.875a0.24 0.24 0 0 1 0.259 -0.077 0.259 0.259 0 0 1 0.163 0.22c0.105 3.009 -1.208 7.494 -3.402 6.948a1.428 1.428 0 0 1 -1.917 1.438 1.783 1.783 0 0 1 -0.259 0.863"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
    </g>
  </svg>
);

export const ShakingHands = () => (
  <svg
    viewBox="-0.5 -0.5 24 24"
    height="1.2em"
    width="1.2em"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.213 15.071H13.417s3.309 0.007 3.354 0l2.089 -0.383a0.958 0.958 0 0 0 0.786 -0.943V8.537a0.958 0.958 0 0 0 -0.609 -0.892L14.203 5.75a1.438 1.438 0 0 0 -1.438 0.229L9.253 8.868a0.737 0.737 0 0 0 0.699 1.27L13.896 8.842"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m3.354 13.154 2.492 0.479 3.436 3.436a0.958 0.958 0 0 0 0.84 0.267l0.479 -0.083a0.958 0.958 0 0 0 0.782 -0.782l0.167 -0.971 1.638 -0.283 0.283 -1.637 1.638 -0.283 0.282 -1.638 -2.492 -2.492"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M11.088 7.358 9.671 5.942A0.958 0.958 0 0 0 8.625 5.733L5.75 6.925l-2.396 0.479"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M0.479 5.967h1.917a0.958 0.958 0 0 1 0.958 0.958v6.708a0.958 0.958 0 0 1 -0.958 0.958h-1.917l0 0v-8.625l0 0Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M20.604 6.925h1.917l0 0v8.625l0 0h-1.917a0.958 0.958 0 0 1 -0.958 -0.958v-6.708a0.958 0.958 0 0 1 0.958 -0.958Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
  </svg>
);

export const TeaCup = () => (
  <svg
    viewBox="-0.5 -0.5 24 24"
    height="1.2em"
    width="1.2em"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.792 0.479A1.694 1.694 0 0 1 4.792 2.875a1.694 1.694 0 0 0 0 2.396"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M9.104 0.479a1.694 1.694 0 0 1 0 2.396 1.694 1.694 0 0 0 0 2.396"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M13.417 0.479A1.694 1.694 0 0 1 13.417 2.875a1.694 1.694 0 0 0 0 2.396"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M16.771 14.854a7.667 7.667 0 0 1 -15.333 0V8.625a0.479 0.479 0 0 1 0.479 -0.479h14.854Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M16.771 8.146H18.208a4.313 4.313 0 0 1 0 8.625h-1.676"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M8.146 15.333a0.479 0.479 0 0 1 -0.479 0.479H4.792a0.479 0.479 0 0 1 -0.479 -0.479v-2.396a1.917 1.917 0 0 1 3.833 0Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m6.229 11.021 0 -3.833"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m0.479 22.521 19.167 0"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
  </svg>
);

export const Vegan = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    height="1.2em"
    width="1.2em"
    aria-hidden="true"
    viewBox="-0.5 -0.5 24 24"
  >
    <path
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2.212 10.306a8.108 8.108 0 0 1 16.115 -0.716"
      strokeWidth="1"
    ></path>
    <path
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M0.767 10.306h11.686"
      strokeWidth="1"
    ></path>
    <path
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10.306 2.674V0.767"
      strokeWidth="1"
    ></path>
    <path
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12.646 19.473s1.347 2.759 3.615 2.553c4.598 -0.421 4.293 -6.532 5.971 -8.691a10.072 10.072 0 0 0 -9.139 0.083c-2.385 1.351 -2.554 3.616 -0.448 6.055Z"
      strokeWidth="1"
    ></path>
    <path
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15.895 16.671s-2.985 0.37 -5.112 5.562l-3.1 -4.059"
      strokeWidth="1"
    ></path>
    <path
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m2.212 10.329 0.771 2.503a0.479 0.479 0 0 0 0.458 0.338h5.741"
      strokeWidth="1"
    ></path>
  </svg>
);

export const VeganCheck = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    height="1.2em"
    width="1.2em"
    aria-hidden="true"
    viewBox="-0.5 -0.5 24 24"
  >
    <path
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m1.917 14.375 6.454 7.906s1.917 -14.375 10.063 -18.688"
      strokeWidth="1"
    ></path>
    <path
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M11.42 11.929a6.414 6.414 0 0 1 0.305 -8.338c2.396 -2.875 9.583 -2.875 9.583 -2.875s0.418 5.175 -1.917 8.625c-2.104 3.109 -5.264 4.251 -7.971 2.588Z"
      strokeWidth="1"
    ></path>
  </svg>
);
